import React, {
  createContext, useState, useMemo, useContext,
} from 'react';

import type { TListType, TListTypeContext } from './types';

export const ListTypeContext = createContext<TListTypeContext | undefined>(undefined);

export function ListTypeProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const [listType, setListType] = useState<TListType>('cards');
  const contextValue = useMemo(() => (
    { listType, setListType }
  ), [listType]);

  return (
    <ListTypeContext.Provider value={contextValue}>
      {children}
    </ListTypeContext.Provider>
  );
}

export function useListTypeContext(): TListTypeContext {
  const context = useContext(ListTypeContext);
  if (!context) {
    throw new Error('useListTypeContext must be used within a ListTypeProvider');
  }
  return context;
}
